import styles from "./index.module.css";
import { useParams } from "react-router-dom";
import { getVehicleByID } from "../../../../redux/features/vehicle/vehicleService";
import { useDispatch, useSelector } from "react-redux";
import { selectVehicle } from "../../../../redux/features/vehicle/vehicleSlice";
import { useEffect, useRef, useState } from "react";
import QuotaCard from "../../../../components/QuotaCard";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import Specifications from "../../../../components/Specifications";
import Skeleton from "react-loading-skeleton";
import SpecificationSkeleton from "../../../../components/Specifications/SpecificationSkeleton";

const Vehicle = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const { data: vehicle, status } = useSelector(selectVehicle);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (id) {
            dispatch(getVehicleByID({ id }));
        }
    }, [dispatch, id]);

    const [selectedImage, setSelectedImage] = useState("");

    useEffect(() => {
        if (vehicle?.image_url) {
            setSelectedImage(vehicle.image_url);
        }
    }, [vehicle]);

    const allImages = [
        ...(vehicle?.image_url ? [{ image_url: vehicle.image_url }] : []),
        ...(vehicle?.vehicle_images || [])
    ];

    // Gallery
    const sliderRef = useRef(null);
    const scrollRight = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollBy({
                top: 300,
                behavior: "smooth",
            });
        }
    };

    const scrollLeft = () => {
        if (sliderRef.current) {
            sliderRef.current.scrollBy({
                top: -300,
                behavior: "smooth",
            });
        }
    };

    // Image preview
    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [zoomed, setZoomed] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const goNext = () => {
        const nextIndex = (currentIndex + 1) % allImages.length;
        setCurrentIndex(nextIndex);
        setSelectedImage(allImages[nextIndex].image_url);
    };

    const goPrev = () => {
        const prevIndex =
            (currentIndex - 1 + allImages.length) % allImages.length;
        setCurrentIndex(prevIndex);
        setSelectedImage(allImages[prevIndex].image_url);
    };

    useEffect(() => {
        if (!isPreviewOpen) return;

        const handleKey = (e) => {
            if (e.key === "ArrowRight") goNext();
            if (e.key === "ArrowLeft") goPrev();
            if (e.key === "Escape") setIsPreviewOpen(false);
        };

        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, [isPreviewOpen, currentIndex]);

    return (
        <div className="main-container">
            {status === null || status === 'loading' ?
                <div className="container-content  wrapped-content">
                    <div className={styles.header}>
                        <div className={styles.headerLeft}>
                            <h2><Skeleton width={400} /></h2>
                            <p><Skeleton width={100} /></p>
                        </div>
                        <div className={styles.headerLeft}>
                            <h2></h2>
                        </div>
                    </div>
                    <div className={styles.body}>
                        <div className={styles.bodyTop}>
                            <div className={styles.bodyLeft}>
                                <div className={styles.leftThumbnail}>
                                    <Skeleton className={styles.thumbImg} height={400} />
                                </div>
                                <div className={styles.leftImages}>
                                    <button
                                        className={`${styles.navBtn} ${styles.up}`}
                                    >
                                        <FaChevronUp />
                                    </button>
                                    <div className={styles.gallery} ref={sliderRef}>
                                        {Array.from(Array(4), (_, i) => {
                                            return (
                                                <div key={i}>
                                                    <Skeleton />
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <button
                                        className={`${styles.navBtn} ${styles.down}`}
                                    >
                                        <FaChevronDown />
                                    </button>
                                </div>
                            </div>
                            <div className={styles.bodyLeftBottom}>
                                <SpecificationSkeleton />
                            </div>
                        </div>
                        <div className={styles.bodyRight}>
                            <QuotaCard />
                        </div>
                    </div>
                </div>
                :
                <div className="container-content  wrapped-content">
                    <div className={styles.header}>
                        <div className={styles.headerLeft}>
                            <h2>{vehicle?.name}</h2>
                            <p>{vehicle?.wheel_drive} | {vehicle?.stock_no} </p>
                        </div>
                        <div className={styles.headerLeft}>
                            <h2></h2>
                        </div>
                    </div>
                    <div className={styles.body}>
                        <div className={styles.bodyTop}>
                            <div className={styles.bodyLeft}>
                                <div className={styles.leftThumbnail}>
                                    <img
                                        src={selectedImage}
                                        alt="thumbnail"
                                        className={styles.thumbImg}
                                        onClick={() => setIsPreviewOpen(true)}
                                    />
                                </div>
                                <div className={styles.leftImages}>
                                    <button
                                        className={`${styles.navBtn} ${styles.up}`}
                                        onClick={scrollLeft}
                                    >
                                        <FaChevronUp />
                                    </button>
                                    <div className={styles.gallery} ref={sliderRef}>
                                        {allImages.map((img, index) => (
                                            <img
                                                key={index}
                                                src={img.image_url}
                                                alt="car"
                                                className={`${styles.galleryImage} ${selectedImage === img.image_url ? styles.active : ""
                                                    }`}
                                                onClick={() => {
                                                    setSelectedImage(img.image_url);
                                                    setCurrentIndex(index);
                                                }}
                                            />
                                        ))}
                                    </div>
                                    <button
                                        className={`${styles.navBtn} ${styles.down}`}
                                        onClick={scrollRight}
                                    >
                                        <FaChevronDown />
                                    </button>
                                </div>
                            </div>
                            <div className={styles.bodyLeftBottom}>
                                <Specifications vehicle={vehicle} />
                                <div className={styles.specContainer}>
                                    <h2 className={styles.specTitle}>Description</h2>
                                    <div className={styles.specList}>
                                        <span className={styles.specValue}>{vehicle?.description}</span>
                                    </div>
                                </div>
                                {vehicle?.vehicle_features?.length > 0 &&
                                    <div className={styles.specContainer}>
                                        <h2 className={styles.specTitle}>Features</h2>
                                        <div className={styles.specList}>
                                            {vehicle?.vehicle_features.map((feature) => (
                                                <span className={styles.specValue}>{feature?.feature?.name}</span>
                                            ))}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className={styles.bodyRight}>
                            <QuotaCard id={id} />
                        </div>
                    </div>
                </div>
            }
            {isPreviewOpen && (
                <div className={styles.modal} onClick={() => setIsPreviewOpen(false)}>

                    {/* LEFT ARROW */}
                    <button
                        className={`${styles.modalArrow} ${styles.left}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            goPrev();
                        }}
                    >
                        ❮
                    </button>

                    {/* IMAGE */}
                    <img
                        src={selectedImage}
                        alt="preview"
                        className={styles.modalImage}
                         onClick={(e) => {
                            e.stopPropagation();
                            setZoomed(!zoomed);
                        }}
                        style={{
                            transform: zoomed ? "scale(2)" : "scale(1)",
                            cursor: zoomed ? "zoom-out" : "zoom-in"
                        }}
                    />

                    {/* RIGHT ARROW */}
                    <button
                        className={`${styles.modalArrow} ${styles.right}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            goNext();
                        }}
                    >
                        ❯
                    </button>
                </div>
            )}
        </div>
    )
}

export default Vehicle;